const aggregate = {
  concat: (list, item) => list.concat(item)
}

const filter = {
  unique: (item, position, array) => array.indexOf(item) === position
}

const by = {
  aggregate,
  filter,
  nameOf: name => item => item.name === name,
  typeOf: type => item => item.type === type,
  valueOf: value => item => item.value === value,
  partNumberOf: partNumber => item => item.partNumber === partNumber,
  attributeOf: ({ type, value }) => item => item.type === type && item.value === value
}

export default by
